module.exports = __webpack_public_path__ + "static/media/expert5.1931e220.png";